module.exports = __webpack_public_path__ + "img/info.0ffb8177.svg";